// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p7-0";
export var leftAlign = "_p7-4";
export var listItem = "_p7-2";
export var listItemWrapper = "_p7-1";
export var operationText = "_p7-3";